(function () {
  function whenSwiperReady(cb) {
    if (typeof window.Swiper === 'function') {
      cb();
      return;
    }
    var tries = 40;
    var timer = setInterval(function () {
      tries -= 1;
      if (typeof window.Swiper === 'function') {
        clearInterval(timer);
        cb();
      } else if (tries <= 0) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initGallery(gallery) {
    if (gallery.dataset.st105Bound) return;
    gallery.dataset.st105Bound = '1';

    var mainEl = gallery.querySelector('[data-st105-main-swiper]');
    if (!mainEl || typeof window.Swiper !== 'function') return;

    var thumbsEl = gallery.querySelector('[data-st105-thumbs-swiper]');
    var prevBtn = gallery.querySelector('[data-st105-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-st105-gallery-next]');
    var slideCount = mainEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    var thumbCount = thumbsEl
      ? thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length
      : 0;

    var thumbsSwiper = null;
    if (thumbsEl && thumbCount > 1) {
      thumbsSwiper = new window.Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesPerGroup: 1,
        speed: 300,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        watchOverflow: true
      });
    }

    var hasNav = slideCount > 1 && (prevBtn || nextBtn);

    var mainSwiper = new window.Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      speed: 300,
      loop: false,
      keyboard: { enabled: true },
      navigation: hasNav
        ? {
            nextEl: nextBtn || null,
            prevEl: prevBtn || null,
            disabledClass: 'swiper-button-disabled'
          }
        : false,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      watchOverflow: true
    });

    // Keep active thumb in view when main advances one-by-one
    mainSwiper.on('slideChange', function () {
      if (!thumbsSwiper) return;
      thumbsSwiper.slideTo(mainSwiper.activeIndex, 300);
    });

    mainSwiper.update();
    if (thumbsSwiper) thumbsSwiper.update();

    if (!hasNav) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }
  }

  function formatTrustScore(score) {
    var n = Number(score);
    if (!isFinite(n)) return '';
    return n.toFixed(1);
  }

  function syncTrustpilotScore(section) {
    if (!section || section.dataset.st105TpSynced) return;
    var buId = section.getAttribute('data-st105-tp-bu');
    var scoreEl = section.querySelector('[data-st105-tp-score]');
    if (!buId || !scoreEl) return;

    section.dataset.st105TpSynced = '1';
    var templateId =
      section.getAttribute('data-st105-tp-template') || '5419b6ffb0d04a076446a9af';
    var locale = section.getAttribute('data-st105-tp-locale') || 'en-US';
    var url =
      'https://widget.trustpilot.com/trustbox-data/' +
      encodeURIComponent(templateId) +
      '?businessUnitId=' +
      encodeURIComponent(buId) +
      '&locale=' +
      encodeURIComponent(locale);

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Trustpilot score fetch failed');
        return res.json();
      })
      .then(function (data) {
        var unit = (data && (data.businessUnit || data.businessEntity)) || {};
        var formatted = formatTrustScore(unit.trustScore != null ? unit.trustScore : unit.stars);
        if (!formatted) return;
        section.querySelectorAll('[data-st105-tp-score]').forEach(function (el) {
          el.textContent = formatted;
        });
      })
      .catch(function () {
        delete section.dataset.st105TpSynced;
      });
  }

  function init(scope) {
    var root = scope || document;

    whenSwiperReady(function () {
      root.querySelectorAll('[data-st105-gallery]').forEach(initGallery);
    });

    root.querySelectorAll('.st105-reviews[data-st105-tp-bu]').forEach(syncTrustpilotScore);
  }

  init(document);

  if (!window.AccStLp105Bound) {
    window.AccStLp105Bound = true;
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  }
})();
